class Mouse {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.bindEvents();
  }

  unmount() {
    document.removeEventListener('mousemove', this.onMouseMove.bind(this));
    this.ui.$items.forEach((item) => {
      item.removeEventListener('mouseover', this.onMouseOver.bind(this));
      item.removeEventListener('mouseout', this.onMouseOut.bind(this));
    });
    this.ui = {};
  }

  bindUI() {
    this.ui = {};
    this.ui.$items = [...document.querySelectorAll('[data-ref="mouse-item"]')];
  }

  bindEvents() {
    document.addEventListener('mousemove', this.onMouseMove.bind(this));
    this.ui.$items.forEach((item) => {
      item.addEventListener('mouseover', this.onMouseOver.bind(this));
      item.addEventListener('mouseout', this.onMouseOut.bind(this));
    });
  }

  onMouseMove(e) {
    this.element.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0)`;
  }

  onMouseOver() {
    this.element.style.opacity = '1';
    this.element.classList.add('is-active');
  }

  onMouseOut() {
    this.element.style.opacity = '0';
    this.element.classList.remove('is-active');
  }
}

export default Mouse;
